exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#photo-controls .bg-black{background:#000}#photo-controls a{transition:.4s ease;opacity:.85;font-size:20px}#photo-controls a:hover{cursor:pointer;opacity:1}#photo-controls i.fa-spin{color:#fff}", ""]);

// exports
